const Tooltip = class Tooltip {
  constructor(content, classnames) {
    this.container = document.createElement('div');
    this.container.setAttribute('role', 'dialog');
    this.container.classList.add('tooltip');
    if (classnames) {
      this.container.classList.add(classnames);
    }
    this.position = null;
    this.container.innerHTML = content;
    this.hidden = true;

    this.onclick = function() {};
    this.onhide = function() {};

    document.body.addEventListener(
      'click',
      () => {
        this.hide();
      },
      false
    );

    this.container.addEventListener(
      'click',
      () => {
        this.onclick();
      },
      false
    );

    this.container.addEventListener(
      'keydown',
      e => {
        const keys = {
          SPACE: 32,
          ENTER: 13,
        };
        if (
          e.type === 'click' ||
          e.keyCode === keys.SPACE ||
          e.keyCode === keys.ENTER
        ) {
          this.onclick();
        }
      },
      false
    );
  }

  get elm() {
    return this.container;
  }

  show() {
    this.container.tabIndex = 0;
    this.container.classList.add('visible');
    this.container.focus();
    this.hidden = false;
  }

  hide() {
    if (!this.hidden) {
      this.container.removeAttribute('tabIndex');
      this.container.classList.remove('visible');
      this.onhide();
      this.hidden = true;
    }
  }

  move(top, left) {
    this.container.style.top = `${top}px`;
    this.container.style.left = `${left}px`;
  }

  onClick(callback) {
    this.onclick = callback;
  }

  onHide(callback) {
    this.onhide = callback;
  }
};

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/tooltip.js